import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { CommonState } from "@obg/ngx.common";
import { ConfigService } from "@obg/ngx.global";
import { TelemetryService } from "@obg/ngx.global.evo";
import { RouteSelector } from "@obg/ngx.router";
import { Observable, of } from "rxjs";
import { switchMap } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class SocialLoginService {
	constructor(
		private service: ConfigService,
		private store: Store<CommonState>,
		private telemetryService: TelemetryService
	) {}

	async getIsGoogleLoginEnabled(): Promise<boolean> {
		const configEnabled = this.isGoogleLoginEnabled();
		const variant = await this.telemetryService.getExperimentVariant("golo", 1000);

		return configEnabled || variant === "1";
	}

	isConnectedAccountMissing$(): Observable<boolean> {
		return this.store.pipe(
			select(RouteSelector.getCurrent),
			switchMap((route) => {
				const queryParam = route?.queryParams?.connectedAccountMissing;

				return of(queryParam === "true");
			})
		);
	}

	isOidcLoginException$(): Observable<boolean> {
		return this.store.pipe(
			select(RouteSelector.getCurrent),
			switchMap((route) => {
				const queryParam = route?.queryParams?.oidcException;

				return of(queryParam === "true");
			})
		);
	}

	private isGoogleLoginEnabled(): boolean {
		return this.service.get((x) => x.common.googleLogin.isEnabled, false);
	}
}
